import { upperFirst } from "lodash-es";

import { UserHomeBaseType } from "Bands/types";
import { copy } from "shared/assets";
import { IFieldType, IFormFields } from "shared/types";

const { userHomeBase, errors } = copy;

export const fields: IFormFields = [
  {
    name: "name",
    label: userHomeBase.fields.name,
    type: IFieldType.text,
    validation: {
      required: errors.required,
    },
  },
  {
    name: "baseType",
    label: userHomeBase.fields.baseType.title,
    placeholder: userHomeBase.fields.baseType.placeholder,
    type: IFieldType.select,
    options: (
      Object.keys(UserHomeBaseType) as Array<keyof typeof UserHomeBaseType>
    ).map((key) => ({
      value: UserHomeBaseType[key],
      label: upperFirst(UserHomeBaseType[key].replace("_", " ")),
    })),
    validation: {
      required: errors.required,
    },
  },
  {
    name: "country",
    label: userHomeBase.fields.country,
    type: IFieldType.country,
    validation: {
      required: errors.required,
    },
  },
  {
    name: "city",
    label: userHomeBase.fields.city,
    type: IFieldType.text,
    validation: {
      required: errors.required,
    },
  },
];
